import { getId } from '../../util/data';
import { Loading } from '../../util/decorators';
import { omit } from '../../util/object';
import { apiFileUpload, apiProductsAdd, apiProductsDelete, apiProductsGet, apiProductsUpdate, type IProduct } from '../api';

export const isEdit = (record: unknown) => Boolean(record && (<any>record).isEdit);

export interface IDataSource extends IProduct {
  isEdit?: boolean;
}

export class ProductService {
  dataSource: IDataSource[] = [];

  dataSourceLoading = false;

  @Loading<ProductService>(['dataSourceLoading'])
  async requestDataSource() {
    const { data } = await apiProductsGet();
    this.dataSource = data;
  }

  async add() {
    this.dataSource.unshift({ id: getId() } as IDataSource);
  }

  async upsert(record: IDataSource, file?: Blob) {
    if (file) {
      const { data } = await apiFileUpload(file);
      record.content = data;
    }
    if (record.id >= 0) {
      await apiProductsUpdate(record);
    } else {
      await apiProductsAdd(omit(record, ['id']));
    }
  }

  async del(id: IDataSource['id']) {
    if (id >= 0) await apiProductsDelete(id);
    this.dataSource.splice(this.dataSource.findIndex(_ => _.id === id), 1);
  }
}

export const productService = new ProductService();